<div class="auth-wrapper">
  <div class="align-items-center grid h-full">
    <div class="col-6 h-full">
      <div class="gc-auth-leftPanel">
        <div class="gc-idnty-container">


          <div class="forcereset-textbox">
            <div class="text-center logo">
              <a href="">
                <img src="../../assets/images/io-logo-green.svg"alt="io-logo.svg"/>
              </a>
            </div>

            <p>It’s that time again !!</p>
            <p>To keep things secure please update your<br>password every 60 days.</p>
            <p>Thanks from the team at io health for<br>updating your password.</p>
          </div>

<!--
          <div class="gc-logo">
            <a href=""
              ><img
                src="../../assets/images/io-logo-green.svg"
                alt="io-logo.svg"
            /></a>
          </div>
          <div class="">
            <p class="mt-5">{{ logoText }}</p>
          </div>
          <div class="gc-exp-title">It’s that time again !!</div>
          <div class="gc-exp-note">
            Thanks from the team at io health for updating your password.
            <div class="flex justify-content-end mt-4">
              <img src="../../assets/images/IOHealth-Text.svg">
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div
      class="col-6 relative justify-content-center flex align-items-center h-full"
    >
      <div class="gc-auth-form-container">
        <div>
          <span class="back-arrow" (click)="navigateToPreviousPage()">
            <em class="pi pi-arrow-left"></em>
          </span>
        </div>
        <h1>Set new password</h1>
        <form
          (ngSubmit)="submitConfirmPasswordForm(confirmPasswordForm)"
          #confirmPasswordForm="ngForm"
        >
          <div class="mt-1 mb-5">
            <p-password
              [(ngModel)]="oldPassword"
              [feedback]="false"
              name="oldpassword"
              [toggleMask]="true"
              placeholder="Old Password"
              required
              #inputFieldOldPassword="ngModel"
              [ngClass]="{'error-border-password': inputFieldOldPassword.touched && !inputFieldOldPassword.value}"
            >
            </p-password>
          </div>

          <div class="mt-1 mb-5">
            <p-password
              [(ngModel)]="newPassword"
              (ngModelChange)="checkPasswordStrength()"
              [feedback]="false"
              name="newpassword"
              [toggleMask]="true"
              placeholder="New Password"
              pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
              required
              #inputFieldNewPassword="ngModel"
              [ngClass]="{'error-border-password': (inputFieldNewPassword.touched && !inputFieldNewPassword.value) ||
               (confirmPasswordDirty || passwordDirty) && repeatPassword !== newPassword}"
            >
            </p-password>
            <span class="password-req">
              {{PASSWORD_STRENGTH_VALIDATION_MESSAGE}}
            </span>
            <div class="flex gap-2 mt-3">
              <div
                class="password-check"
                [ngClass]="[
                  passwordStrength == 'Weak'
                    ? 'weak-password'
                    : '' || passwordStrength == 'Medium'
                    ? 'medium-password'
                    : '' || passwordStrength == 'Strong'
                    ? 'strong-password'
                    : ''
                ]"
              ></div>
              <div
                class="password-check"
                [ngClass]="[
                  passwordStrength == 'Weak'
                    ? 'weak-password'
                    : '' || passwordStrength == 'Medium'
                    ? 'medium-password'
                    : '' || passwordStrength == 'Strong'
                    ? 'strong-password'
                    : ''
                ]"
              ></div>
              <div
                class="password-check"
                [ngClass]="[
                  passwordStrength == 'Medium'
                    ? 'medium-password'
                    : '' || passwordStrength == 'Strong'
                    ? 'strong-password'
                    : ''
                ]"
              ></div>
              <div
                class="password-check"
                [ngClass]="
                  passwordStrength == 'Strong' ? 'strong-password' : ''
                "
              ></div>
            </div>
            <div class="password-strength-container">
              <span
                *ngIf="passwordStrength === 'Weak'"
                class="weak-password-text"
              >
                Weak
              </span>
              <span
                *ngIf="passwordStrength === 'Medium'"
                class="medium-password-text"
              >
                Medium
              </span>
              <span
                *ngIf="passwordStrength === 'Strong'"
                class="strong-password-text"
              >
                Strong
              </span>
            </div>
          </div>

          <div class="mt-1 mb-5">
            <p-password
              type="password"
              [(ngModel)]="repeatPassword"
              [toggleMask]="true"
              name="repeatpassword"
              [feedback]="false"
              placeholder="Confirm Password"
              (ngModelChange)="confirmPasswordDirty = true"
              pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
              required
              #inputFieldRepeatPassword="ngModel"
              [ngClass]="{'error-border-password': (inputFieldRepeatPassword.touched && !inputFieldRepeatPassword.value) ||
               (confirmPasswordDirty || passwordDirty) && repeatPassword !== newPassword}"
            ></p-password>
            <span
              class="password-req c-r"
              *ngIf="
                (confirmPasswordDirty || passwordDirty) &&
                repeatPassword !== newPassword
              "
            >
              {{PASSWORDS_MUST_MATCH}}
            </span>
          </div>

          <button
            type="submit"
            class="login-btn"
          >
            Reset Password
          </button>
        </form>
      </div>

      <app-footer></app-footer>
    </div>
  </div>
</div>
